<template>
  <v-avatar
    v-if="showImage"
    :size="squareSize"
    :tile="tile"
  >
    <img
      :src="imageUrl"
      :alt="servicerName"
      @error="validImage = false"
    >
  </v-avatar>
  <v-avatar
    v-else-if="showIcon"
    :color="avatarColor"
    :size="squareSize"
    :tile="tile"
    dark
  >
    <v-icon
      dark
      :x-large="xLarge"
      :large="large"
      :medium="medium"
      :small="small"
    >
      {{ icon }}
    </v-icon>
  </v-avatar>
  <v-avatar
    v-else-if="showAccountIcon"
    :size="squareSize"
    :tile="tile"
  >
    <v-icon large>
      account_circle
    </v-icon>
  </v-avatar>
  <v-avatar
    v-else
    :size="squareSize"
    :color="avatarColor"
    :tile="tile"
  >
    <span
      :style="`font-size: ${initialSize}px;`"
      class="white--text"
    >
      {{ initials }}
    </span>
  </v-avatar>
</template>

<script>
export default {
  name: 'DefaultAvatar',
  props: {
    avatarColor: {
      type: String,
      default: 'primary',
      required: false
    },
    icon: {
      type: String,
      default: '',
      required: false
    },
    initialSize: {
      type: String,
      default: '28',
      required: false
    },
    imageUrl: {
      type: String,
      default: '',
      required: false
    },
    large: {
      type: Boolean,
      default: true
    },
    medium: {
      type: Boolean,
      default: false
    },
    servicerName: {
      type: String,
      default: 'Servicer Profile Image',
      required: false
    },
    showAccountIcon: {
      type: Boolean,
      default: false,
      required: false
    },
    showIcon: {
      type: Boolean,
      default: false,
      required: false
    },
    small: {
      type: Boolean,
      default: false
    },
    squareSize: {
      type: String,
      default: '60',
      required: false
    },
    tile: {
      type: Boolean,
      default: true,
      required: false
    },
    useFullInitials: {
      type: Boolean,
      default: false
    },
    xLarge: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      validImage: true
    }
  },
  computed: {
    initials () {
      if (this.useFullInitials && this.servicerName.split(' ').length > 1) {
        // a bit complicated for what it's doing but its to avoid issues with middle names etc
        const names = this.servicerName.split(' ')
        const firstName = names.shift()
        const lastName = names.pop()

        return `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`
      } else {
        return this.servicerName.charAt(0).toUpperCase()
      }
    },
    showImage () {
      if (this.validImage && this.imageUrl && this.imageUrl !== '' && this.imageUrl !== 'https://simplenexus.com/images/profile_sihlouette.png') return true
      return false
    }
  }
}
</script>
